import { ConfirmationDialog } from "components/confirmationDialog/confirmationDialog";
import { I18nMessage } from "components/i18n/I18nMessage";

export class PreventBrowseOutDialog {
    public confirmRoute(acceptCallback, message) {
        let def = {
            confirmationMessages: [new I18nMessage(message)],
            confirmationAccept: new I18nMessage("dialog.button.accept"),
        };
        const dialog = new ConfirmationDialog({ ...def, acceptCallback });
        dialog.open();
    }
}
